import {
  createContext,
  Dispatch,
  MutableRefObject,
  ReactNode,
  SetStateAction,
  useContext,
  useRef,
  useState,
} from 'react';
import { TargetInfoType } from '@ais-ui/websockets';

export interface TargetChooserContextValue {
  showChooseTargetPanel: boolean;
  setShowChooseTargetPanel: Dispatch<SetStateAction<boolean>>;
  onChooseTarget: MutableRefObject<((target: TargetInfoType) => void) | null>;
  onRejectTarget: MutableRefObject<(() => void) | null>;
  chooseTargetTypes: string[];
  setChooseTargetTypes: Dispatch<SetStateAction<string[]>>;
}

const TargetChooserContext = createContext<
  TargetChooserContextValue | undefined
>(undefined);

export const TargetChooserProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [showChooseTargetPanel, setShowChooseTargetPanel] =
    useState<boolean>(false);
  const onChooseTarget = useRef<((target: TargetInfoType) => void) | null>(
    null,
  );
  const onRejectTarget = useRef<(() => void) | null>(null);
  const [chooseTargetTypes, setChooseTargetTypes] = useState<string[]>([]);

  return (
    <TargetChooserContext.Provider
      value={{
        showChooseTargetPanel,
        setShowChooseTargetPanel,
        onChooseTarget,
        onRejectTarget,
        chooseTargetTypes,
        setChooseTargetTypes,
      }}
    >
      {children}
    </TargetChooserContext.Provider>
  );
};

export const useTargetChooser = () => {
  const context = useContext(TargetChooserContext);
  if (!context) {
    throw new Error(
      'useTargetChooser must be used within a TargetChooserProvider',
    );
  }
  return context;
};
